import { render } from "./SetConfigModal.vue?vue&type=template&id=5873628c&ts=true"
import script from "./SetConfigModal.vue?vue&type=script&lang=ts"
export * from "./SetConfigModal.vue?vue&type=script&lang=ts"

import exportComponent from "/var/jenkins_home/workspace/saas-distribution-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__